module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//btn-1.png?v=e8e826a0";